// axios.js

import router from '@/router'
import { clearCookie } from '@/utils/cookies'
import axios, { HttpStatusCode } from 'axios'
import store from '@/store'
import { Base64 } from 'js-base64'

export const HttpErrCode = {
  // 未审核通过用户禁止登录
  USER_NOT_AUDIT: 14012,
}
const httpCodeServerErrorArray = [
  // `Jackson `序列化异常`
  1001,
  // `Jackson `序列化初始化异常`
  1002,
  // `方法参数校验异常`
  1003,
  // `方法参数校验异常`
  1004,
  // `方法参数格式有误`
  1005,
  // `请求参数缺失`
  1006,
  // `不支持的Http请求方式`
  1007,
  // `未知异常,请联系管理员`
  1008,
  // `重复请求,请稍后再试`【分布式锁】
  1009,
  // `操作失败：加锁异常`【分布式锁】
  1010,
  // `操作失败：加锁异常`【分布式锁】
  1011,
  // 未审核通过用户禁止登录
  14012,
]

const httpCodeAuthErrorArray = [
  // `无登录凭证`
  2100,
  // `账号已在其他地方登录`
  2108,
  // `登录凭证无效`
  2101,
  // `登录凭证错误，请检查`
  2102,
  // `权限不足`
  2103,
  // `登录凭证已过期`
  2104,
  // `鉴权错误，请联系管理员`
  2105,
  // `鉴权错误，账号异常`
  2106,
  // 用户不存在
  13007
]
/** 服务器重启异常 */
export const HttpServerUpdateCode = 15011


// 请求拦截器
import CryptoJS from 'crypto-js' // 假设您会使用 CryptoJS 进行加签
import forge from 'node-forge'
const publicKeyPEM = '-----BEGIN PUBLIC KEY-----\n' +
  'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBALqnZLMc4NIIsfdLoy0o7mimK8c8B6pR\n' +
  'gPVAxdrlJo/stqmK44AmA4QK0hFb7GVIlNkiWNeABVd6/RCvibGRnTUCAwEAAQ==\n' +
  '-----END PUBLIC KEY-----'
axios.defaults.baseURL = process.env.VUE_APP_BASE_API
const sortParam = (params) => {
  const newKey = Object.keys(params || {}).sort()
  let newObj = {}
  for (let i = 0; i < newKey.length; i++) {
    newObj[newKey[i]] = params[newKey[i]]
  }
  return newObj
}

const getSignParam = (config) => {
  // 时间戳
  const timestamp = new Date().getTime().toString()
  // 请求param参数
  const body = sortParam(config.params)
  // 随机数
  const random = Math.random().toString(36).substring(2)
  return { timestamp, body, random }
}

const parseQueryParam = (config) => {
  if (config.url && config.url.includes('?')) {
    // 使用新的URL替换旧的URL
    const urlParts = config.url.split('?')
    const queryParamsString = urlParts[1]
    const queryParams = new URLSearchParams(queryParamsString)
    const queryParamsObject = Object.fromEntries(queryParams.entries())
    config.url = urlParts[0]
    config.params = { ...config.params, ...queryParamsObject }
  }
  return config
}

const HTTP_CHANEL_ENUM = {
  // 中台
  GATHER: 'gather_middle',
  // 后台
  GATHER_BOOT: 'gather_backend',
  // 小程序
  GATHER_MINI: 'gather_mini',
  // H5
  GATHER_H5: 'gather_h5',
  // 官网
  GATHER_OFC: 'gather_official',
}

axios.interceptors.request.use((config) => {
  // add token to header
  config.headers['Authorization'] = window.localStorage.getItem('token')
  // add channel to header
  config.headers['Channel'] = HTTP_CHANEL_ENUM.GATHER_OFC
  if (config.data) {
    // 删除空字符串的属性
    for (let key in config.data) {
      if (config.data[key] === '') {
        delete config.data[key]
      }
    }
  }
  // 将queryParam解析为对象params
  config = parseQueryParam(config)
  const signParam = getSignParam(config)
  const { timestamp, body, random } = signParam
  if (config.method === 'post' || config.method === 'put') {
    signParam.body = sortParam({
      ...config.data,
      urlParams: body,
    })
  }
  signParam.body = JSON.stringify(signParam.body)
  // 签名
  const sign = CryptoJS.MD5(JSON.stringify(sortParam(signParam)))
  config = Object.assign(config, { headers: { ...config.headers, sign, timestamp, random } })
  return config
})

axios.interceptors.response.use(res => {
  // 如果结果加签了-才需要验签
  if (res.headers.timestamp && res.headers.sign) {
    // 得到真实的公钥信息
    const publicKey = forge.pki.publicKeyFromPem(publicKeyPEM)
    const signature = forge.util.decode64(res.headers.sign)
    // 验签
    const signParam = JSON.stringify({ result: res.data, timestamp: res.headers.timestamp })
    const md = forge.md.sha256.create()
    md.update(signParam, 'utf8')
    const verify = publicKey.verify(md.digest().bytes(), signature)
    console.log('验签结果', verify)
    // 当结果为true时，验签成功，否则验签失败
    if (!verify) {
      return { data: { code: 500, msg: '抱歉，当前操作遇到问题，请稍后再试。', message: '抱歉，当前操作遇到问题，请稍后再试。' } }
    }
  }
  if (res.data.message === '当前用户未加入企业') {
    res.data.code = 200
    res.data.result = null
  }
  // 处理服务不可用异常 维护中界面
  if (res.data.code === HttpServerUpdateCode) {
    store.commit('setSysUpdate', true)
  }
  // 处理鉴权异常
  if (httpCodeAuthErrorArray.includes(res.data.code)) {
    window.localStorage.clear('token')
    router.push('/login')
  }
  if (!res?.data?.data) {
    res.data.data = res.data.result
  }
  return res
})

// 获取广告图
export const getBannerApi = params => {
  return axios.get('/business/advertisement/write/banner/' + params)
}

// 官网资讯分页查询
export const newsListApi = params => {
  return axios.get('/business/article/write/page?current=' + params.current + '&size=' + params.size + '&cate=' + params.cate + '&title=' + params.title + '&createName=' + params.createName + '&recommend=' + params.recommend + '&titleSort=' + params.titleSort + '&createTimeSort=' + params.createTimeSort)
}

// 获取资讯详情
export const newsDetailApi = params => {
  return axios.get('/business/article/info?id=' + params)
}

// 首页询价商品统计
export const homeCountApi = params => {
  return axios.get('/business/foreground/report/horizon/getGwEnquiryProducts?current=' + params.current + '&size=' + params.size + '&type=' + params.type)
}

// 首页采购次数统计
export const homePurchaseApi = params => {
  return axios.get('/business/foreground/report/horizon/getGwBuyCount?current=' + params.current + '&size=' + params.size)
}

// 首页采购金额统计
export const homeAmountApi = params => {
  return axios.get('/business/foreground/report/horizon/getGwBuyAmount?current=' + params.current + '&size=' + params.size)
}

// 首页供应次数统计
export const homeSupplyApi = params => {
  return axios.get('/business/foreground/report/horizon/getGwSellCount?current=' + params.current + '&size=' + params.size)
}

// 首页供应金额统计
export const homeSupplyAmountApi = params => {
  return axios.get('/business/foreground/report/horizon/getGwSellAmount?current=' + params.current + '&size=' + params.size)
}

// 获取资讯分类
export const newsCateApi = params => {
  return axios.get('/user/sys/dict/getDictItems/cate_category')
}


// 校验手机号是否注册
export const checkPhoneApi = params => {
  return axios.get('/business/FOR_/login/checkPhone?phone=' + params.phone)
}

// 校验验证码是否正确
export const checkCodeApi = params => {
  return axios.post('/business/FOR_/login/changeCode?phone=' + params.phone + '&code=' + params.code)
}

// 修改密码
export const editPswApi = params => {
  return axios.post('/business/FOR_/login/changePsw?phone=' + params.phone + '&code=' + params.code + '&psw=' + params.psw)
}

// 发送验证码
export const sendCodeApi = params => {
  return axios.get('/business/FOR_/login/sendMessage?phone=' + params.phone + '&type=' + params.type)
}


export const loginOutApi = params => {
  return axios.get('/business/FOR_/login/loginOut')
}
// 注册
export const registerApi = params => {
  return axios.post('/business/FOR_/login/sign', { ...params, channel: HTTP_CHANEL_ENUM.GATHER })
}

// 登录
export const loginApi = params => {
  const req = {
    ...params,
    psw: 'hAw6eqnFLKxpsDv3' + Base64.encode(params.psw)
  }
  return axios.get('/business/FOR_/login/phonePswLogin?phone=' + req.phone + '&psw=' + req.psw + '&channel=' + HTTP_CHANEL_ENUM.GATHER)
}
// 验证码登录
export const codeLoginApi = params => {
  return axios.get('/business/FOR_/login/phoneCodeLogin?phone=' + params.phone + '&code=' + params.code + '&channel=' + HTTP_CHANEL_ENUM.GATHER)
}